import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { useFormik } from "formik";
import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";
import * as toast from "../../utils/makeToast";
import { getLocalStorageItem } from "../../utils/localStorage";
// import './UploadDocumentDialog.css'
import { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { trimImageURI } from "../../utils/imageUpload";
import {
  accountOpeningSteps,
  idCardErrorMsg,
  idCardValidationRegex,
} from "../../utils/constants";
import ChequeBookModal from "../ChequeBookModal";
import "youverify-web-sdk";
import Loader from "../Loader";
import {
  handleNumericInput,
  handleNumericPaste,
  returnInputErrorMessage,
} from "../../utils/helpers";
import apiHooks from "../../customHooks/apis";
import DocUpload from "../DocUpload";
import CustomDropdown from "../CustomDropdown";
import useUserValidated from "../../customHooks/useUserValidated";
import CustomInputField from "../CustomInputField/CustomInputField";
import ImageUploadAndLivePhoto from "../ImageUploadAndLivePhoto";
import useValidateCurrency from "../../customHooks/useValidateCurrency";
import { pushDocumentsUploaded } from "../../utils/dataLayerEvents";
import CameraComponent from "../CameraComponent";
import UploadSignatureCard from "../UploadSignatureCard";
import SignaturePad from "../SignaturePad";
import CustomModal from "../Modal/CustomModal";
interface IuploadPayload {
  id: number;
  uploadSignature: string;
  frontPageId: string;
  currencyOfAccountUSD: string;
  currencyOfAccountGBP: string;
  currencyOfAccountEURO: string;
  debitCardValueAddedService: boolean;
  accountTypecode: string;
  accountTypeName: string;
  utilityBill: string;
  identityCardType: number;
  idCardNumber: string;
  issueDate: string;
  expiryDate: string;
  uploadPicture: string;
}
function UploadDocumentDomiciliaryCurrentDialog(props: any) {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      id: 0,
      uploadSignature: "",
      frontPageId: "",
      currencyOfAccountUSD: "",
      currencyOfAccountGBP: "",
      currencyOfAccountEURO: "",
      debitCardValueAddedService: true,
      accountTypecode: "",
      accountTypeName: "",
      utilityBill: "",
      identityCardType: 5,
      idCardNumber: "",
      issueDate: "",
      expiryDate: "",
      uploadPicture: localStorage.getItem("userImage") || "",
    },
    validationSchema: yup.object({
      id: yup.string().required(),
      frontPageId: yup.string().required("Front Page ID is required"),
      debitCardValueAddedService: yup.boolean().required(),
      identityCardType: yup
        .number()
        .integer()
        .min(0)
        .required("Identity Card Type is required"),
      idCardNumber: yup
        .string()
        .required("ID card number is required")
        .when(
          "identityCardType",
          (identityCardType: number, schema: yup.StringSchema) => {
            return (
              schema.matches(
                idCardValidationRegex[identityCardType],
                idCardErrorMsg[identityCardType],
              ) || schema
            );
          },
        ),
      uploadPicture: yup.string().required("Live photo is required"),
      utilityBill: yup.string().required("Utility bill is required"),
      uploadSignature: yup.string().required("Signature is required"),
      currencyOfAccountEURO: yup.string(),
      currencyOfAccountGBP: yup.string(),
      currencyOfAccountUSD: yup.string(),
    }),
    validateOnMount: true,
    onSubmit(values) {
      uploadDcouments(values);
    },
  });
  useValidateCurrency(formik);

  const [updating, setUpdating] = useState(false);

  const [signatureImageUrl, setSignatureImageUrl] = useState("");
  const [pictureImageUrl, setPictureImageUrl] = useState("");
  const [frontPageImageUrl, setFrontPageImageUrl] = useState("");
  const [refereeFormImageUrl, setRefereeFormImageUrl] = useState("");
  const [utilityBillImageUrl, setutilityBillImageUrl] = useState("");
  const { useGetMeansOfId, useUploadFile, useGetCurrencies } = apiHooks;
  const { idTypes } = useGetMeansOfId();
  const {
    currencies,
    handleGetGlCode,
    gettingCurrencies,
    getForeignCurrencies,
  } = useGetCurrencies();
  const { uploadingFile, handleUploadFile } = useUploadFile();
  const [signatureImageBase64, setSignatureImageBase64] = useState("");
  const [pictureImageBase64, setPictureImageBase64] = useState("");
  const [frontPageImageBase64, setFrontPageImageBase64] = useState("");
  const [refereeFormImageBase64, setRefereeFormImageBase64] = useState("");
  const [utilityBillImageBase64, setUtilityBillImageBase64] = useState("");

  const [settingSignatureImage, setSettingSignatureImage] =
    useState<boolean>(false);
  const [settingPictureImage, setSettingPictureImage] =
    useState<boolean>(false);
  const [settingFrontPageImage, setSettingFrontPageImage] =
    useState<boolean>(false);
  const [settingRefereeFormImage, setSettingRefereeFormImage] =
    useState<boolean>(false);
  const [settingutilityBillImage, setSettingUtilityBillImage] =
    useState<boolean>(false);

  const [selected, setSelected] = useState<any>([]);
  const [isUploading, setIsUploading] = useState(false);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails"),
  );
  const [showCamera, setShowCamera] = useState<boolean>(false);
  const [livePictureDocumentName, setLivePictureDocumentName] =
    useState<string>("");

  const [showSignaturePad, setShowSignaturePad] = useState<boolean>(false);
  const [signatureName, setSignatureName] = useState<string>("");
  const validationType = localStorage.getItem("validationType");

  const goToStep = (step: any) => {
    if (step === "update-detail") {
      localStorage.setItem("previous-screen", "document-upload");
    }
    dispatch(setAccountOpeningStep(step));
  };

  let fileUploadObj: any;

  //https://k2testcontainer4.blob.core.windows.net/testcontainer1/NEWACCOUNTOPENING/FILE/OnlineAccountBuild01%5COnlineAccountBuild01/bfbd0c59-462c-4072-b7ec-582a89810f76image.jpeg"

  const uploadDcouments = (values: IuploadPayload) => {
    let uploadDocumentPayload = {
      ...values,
      id: userDetails?.uploadid,
      accountTypeName: localStorage.getItem("altFinanceAccountType"),
    } as IuploadPayload;

    if (!uploadDocumentPayload.uploadSignature) {
      toast.errorToast("Please provide a signature");
      return;
    }

    if (!uploadDocumentPayload.utilityBill) {
      toast.errorToast("Please provide a Utility Bill");
      return;
    }

    //
    // return
    setUpdating(true);
    axios
      .post(
        `${baseUrl}DomiciliaryCurrent/DomiciliaryCurrentDocumentUpload`,
        uploadDocumentPayload,
      )
      .then((response) => {
        setUpdating(false);
        if (
          response?.data?.length > 0 &&
          response?.data[0]?.responseCode == "20"
        ) {
          toast.errorToast(response?.data[0]?.responseMessage);
          return;
        }
        if (response?.data[0]?.accountNo) {
          localStorage.setItem(
            "generatedAccountNumber",
            response.data[0].accountNo,
          );
          pushDocumentsUploaded("personal");
          dispatch(
            setAccountOpeningStep(accountOpeningSteps.accountOpeningSuccess),
          );
          return;
        }

        if (response?.data[0]?.responseCode !== "00") {
          toast.errorToast(response?.data?.[0]?.responseMessage);
          return;
        }

        if (!response?.data?.isSuccess || !response?.data[0]?.accountNo) {
          toast.errorToast(response?.data[0]?.responseMessage);
          return;
        }

        localStorage.setItem(
          "generatedAccountNumber",
          response.data[0].accountNo,
        );
        dispatch(setAccountOpeningStep("account-opening-success"));
      })
      .catch((err) => {
        setUpdating(false);
        // toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
        toast.errorToast("Something went wrong");
        // dispatch(setAccountOpeningStep('account-opening-success'))
      });
  };

  useEffect(() => {
    formik.setValues({ ...formik.values, idCardNumber: userDetails.nin || "" });
  }, [JSON.stringify(userDetails)]);

  const uploadImage = (payload: any, type: string) => {
    if (type === "signature") {
      setSignatureImageBase64(payload.postedFilebase64);
      setSettingSignatureImage(true);
    }
    if (type === "frontPageId") {
      setFrontPageImageBase64(payload.postedFilebase64);
      setSettingFrontPageImage(true);
    }

    if (type === "utilityBill") {
      setUtilityBillImageBase64(payload.postedFilebase64);
      setSettingUtilityBillImage(true);
    }
    if (type === "image") {
      setPictureImageBase64(payload.postedFilebase64);
      setSettingPictureImage(true);
    }
    if (type === "referralForm") {
      setRefereeFormImageBase64(payload.postedFilebase64);
      setSettingRefereeFormImage(true);
    }
    // return
    axios
      .post(`${baseUrl}Authentication/UploadFile`, payload)
      .then((response) => {
        if (type == "signature") {
          setSignatureImageUrl(response.data?.id);
          formik.setFieldValue("uploadSignature", response.data?.id);
          setSettingSignatureImage(false);
        } else if (type == "frontPageId") {
          setFrontPageImageUrl(response.data?.id);
          setSettingFrontPageImage(false);
        } else if (type == "image") {
          setPictureImageUrl(response.data?.id);
          setSettingPictureImage(false);
        } else if (type == "utilityBill") {
          setutilityBillImageUrl(response.data?.id);
          formik.setFieldValue("utilityBill", response.data?.id);
          setSettingUtilityBillImage(false);
        } else if (type == "referralForm") {
          setRefereeFormImageUrl(response.data?.id);
          setSettingRefereeFormImage(false);
        }
      })
      .catch((err) => {
        setSettingSignatureImage(false);
        setSettingFrontPageImage(false);
        setSettingPictureImage(false);
        setSettingRefereeFormImage(false);
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message,
        );
      });
  };

  const handleSubmit = (type: string) => {
    uploadImage(fileUploadObj, type);
  };

  const handleTakePhoto = (dataUri: any) => {
    let res = trimImageURI(dataUri);
    setPictureImageUrl("data:image/jpg;base64," + res);
    setShowCamera(false);
    fileUploadObj = {
      postedFilebase64: dataUri,
      documentName: livePictureDocumentName,
      filetype: "png",
    };
    handleSubmit(livePictureDocumentName);
    setShowCamera(false);
  };

  const handleCameraError = (error: any) => {
    toast.errorToast("Something went wrong, please try again");
  };

  const handleCameraStart = () => {
    //
  };

  const handleCameraStop = () => {
    //
  };

  let sigPad: any = {};

  const { isValidated } = useUserValidated();
  const [loading, setLoading] = useState(false);

  const handleSelectCurrency = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    formik.setFieldValue("currencyOfAccountUSD", "");
    formik.setFieldValue("currencyOfAccountGBP", "");
    formik.setFieldValue("currencyOfAccountEURO", "");
    const { value } = event.target;
    if (!value) return;
    const selectedCurrency = currencies?.find(
      (item) => String(item.currencY_CODE) === value.toString(),
    );
    if (!selectedCurrency) return;
    const currencyShort = selectedCurrency.brieF_DESC_ENG || "";
    localStorage.setItem("currency", currencyShort);
    const fieldName = `currencyOfAccount${
      +value == 978 ? `${currencyShort}O` : currencyShort
    }`;
    formik.setFieldValue(fieldName, value.toString());
    formik
      .setFieldValue("accountTypecode", handleGetGlCode(+value))
      .then(() => {
        const { accountTypecode, ...rest } = formik.errors;
        formik.setErrors(rest);
      });
  };

  function checkIsvalidated() {
    if (validationType === "bvn") {
      return false;
    } else {
      return !isValidated;
    }
  }

  const handleClickSave = (
    postedFilebase64: string,
    documentName: string,
    filetype: string,
    objectUrl: string,
  ) => {
    handleUploadFile(
      {
        postedFilebase64,
        documentName,
        filetype,
      },
      (url) => {
        setSignatureImageBase64(objectUrl);
        formik.setFieldValue("uploadSignature", url);
        setSignatureName("draw");
      },
    );
    setShowSignaturePad(false);
  };

  return (
    <div>
      {loading && <Loader />}
      {showCamera && (
        <div style={{ overflowX: "scroll" }} className="pt-2">
          <CameraComponent
            onTakePhoto={(dataUri) => {
              handleTakePhoto(dataUri);
            }}
            onCameraError={(error) => {
              handleCameraError(error);
            }}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            idealResolution={{ width: 640, height: 480 }}
            imageType={IMAGE_TYPES.PNG}
            imageCompression={0.97}
            isMaxResolution={false}
            isImageMirror={false}
            isSilentMode={false}
            isDisplayStartCameraError={true}
            isFullscreen={false}
            sizeFactor={1}
            onCameraStop={() => {
              handleCameraStop();
            }}
            onCameraStart={() => {
              handleCameraStart();
            }}
          />
        </div>
      )}

      <form onSubmit={formik.handleSubmit}>
        <div className=" card-form pl-1 pr-1 ">
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-5">
              <a href="">Document upload</a>
            </h4>
            <p className="text-center">
              <small>
                The file format should be JPEG, PNG or PDF (max size:2mb)
              </small>
            </p>

            <div className="row align-items-end">
              {(!signatureName || signatureName === "upload") && (
                <div
                  className={
                    signatureName === "upload" ? "col-lg-6" : "col-lg-3"
                  }
                >
                  <DocUpload
                    name="uploadSignature"
                    label="Draw/Upload Signature"
                    required
                    show
                    getFileUrl={(name, url) => {
                      formik.setFieldValue(name, url);
                      setSignatureName(url ? "upload" : "");
                    }}
                    setIsUploading={setIsUploading}
                    disabled={uploadingFile}
                  />
                </div>
              )}
              {(!signatureName || signatureName === "draw") && (
                <div
                  className={signatureName === "draw" ? "col-lg-6" : "col-lg-3"}
                >
                  <UploadSignatureCard
                    uploading={uploadingFile}
                    imageUrl={signatureImageBase64}
                    show
                    onClickCard={() => setShowSignaturePad(true)}
                    handleRemoveFile={(url) => {
                      formik.setFieldValue("uploadSignature", url);
                      setSignatureName("");
                      setSignatureImageBase64("");
                    }}
                    disabled={isUploading}
                  />
                </div>
              )}

              <div className="col-lg-6">
                <ImageUploadAndLivePhoto
                  getFileUrl={(url) =>
                    formik.setFieldValue("uploadPicture", url)
                  }
                />
              </div>
            </div>

            {/* ----------------------- */}

            <div className="w-100 mt-2">
              <DocUpload
                label="Upload utility bill (not older than 3 months)"
                required
                show
                errorMessage={returnInputErrorMessage<IuploadPayload>(
                  formik,
                  "utilityBill",
                )}
                name="utilityBill"
                getFileUrl={formik.setFieldValue}
              />
            </div>

            <div className="row">
              <label
                htmlFor="residentialaddress"
                className="label_text my-2 mt-4 font-weight-bold"
                style={{ display: "block", textAlign: "center" }}
              >
                <b>Means of Identification Document</b>
              </label>
            </div>

            <div className="col mt-4"></div>

            <div className="row mb-4 mt-4">
              <div className="col-md-6">
                <CustomInputField
                  label="Identity Card Type"
                  value="National Identity Card"
                  required
                  disabled
                />
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <CustomInputField
                    required
                    label="National Identity Number (NIN)"
                    name="idCardNumber"
                    onChange={formik.handleChange}
                    value={formik.values.idCardNumber}
                    onKeyDown={(e) =>
                      handleNumericInput(e, formik.values.identityCardType)
                    }
                    onPaste={(e) =>
                      handleNumericPaste(e, formik.values.identityCardType)
                    }
                    type="text"
                    id="name"
                    onBlur={formik.handleBlur}
                    placeholder="Enter ID card number"
                    errorMessage={
                      returnInputErrorMessage<typeof formik.initialValues>(
                        formik,
                        "idCardNumber",
                      ) as string
                    }
                    disabled
                  />
                </div>
              </div>
            </div>

            <div>
              <DocUpload
                name="frontPageId"
                show
                required
                label="Front page of ID"
                getFileUrl={formik.setFieldValue}
                bottomText="The file format should be JPEG, PNG or PDF  (max size: 2mb)"
              />
            </div>

            <div className="row mt-4">
              <div className="col-lg-6">
                <CustomDropdown
                  required
                  label="Currencies of account to be opened"
                  placeholder="Select currency"
                  options={getForeignCurrencies()}
                  labelKey="lonG_DESC_ENG"
                  valueKey="currencY_CODE"
                  onClickOption={handleSelectCurrency}
                  onBlur={formik.handleBlur}
                  errorMessage={
                    formik.touched["currency"] ? formik.errors["currency"] : ""
                  }
                  name="currency"
                  formik={formik}
                  disabled={gettingCurrencies}
                />
              </div>
              <div className="col-lg-6">
                <label
                  style={{ fontSize: "12px" }}
                  className="custom-control-label mb-2"
                  htmlFor="checkbox3"
                >
                  Would you like to have a Debit Card (Verve)
                </label>
                <div className="row " id="dvPassport">
                  <div className="col-md-3 form-group">
                    <div className="d-flex  input-group ">
                      <input
                        name="debitCardValueAddedService"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "debitCardValueAddedService",
                            e.target.value === "true",
                          )
                        }
                        value="true"
                        type="radio"
                        className="custom-control-input debit-card-radio-input"
                        id="rad1"
                        checked={
                          formik.values.debitCardValueAddedService === true
                        }
                      />
                      <label
                        className="custom-control-label pl-3"
                        htmlFor="rad2"
                      >
                        Yes
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4 mb-4">
                    <div className="custom-control custom-radio input-group mb-2">
                      <input
                        name="debitCardValueAddedService"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "debitCardValueAddedService",
                            e.target.value === "true",
                          )
                        }
                        value="false"
                        type="radio"
                        className="custom-control-input debit-card-radio-input"
                        id="rad2"
                        checked={
                          formik.values.debitCardValueAddedService === false
                        }
                      />
                      <label
                        className="custom-control-label pl-3"
                        htmlFor="rad2"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-2">
            <div className="mb-3 mr-4" style={{ marginRight: "20px" }}>
              <button
                onClick={() => {
                  goToStep(accountOpeningSteps.addReference);
                }}
                className="btn btn-outline-gold mr-3 btn-filled-white"
              >
                Previous
              </button>
            </div>
            {updating ? (
              <div className="spinner-border text-gold" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button
                disabled={!formik?.isValid || checkIsvalidated() || !selected}
                type="submit"
                className="btn btn-filled-red"
              >
                Proceed
              </button>
            )}
          </div>
        </div>
        <CustomModal
          show={showSignaturePad}
          onClickClose={() => setShowSignaturePad(false)}
        >
          <SignaturePad onClickSave={handleClickSave} />
        </CustomModal>
      </form>

      {/*  */}
      <button
        id="chequeBookModalButton"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#chequeBookModal"
      >
        test
      </button>
      <div
        className="modal fade"
        id="chequeBookModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content chequebook-modal-content">
            <div className="modal-body">
              <ChequeBookModal />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
    </div>
  );
}

export default UploadDocumentDomiciliaryCurrentDialog;
